import { useCallback, useEffect, useState } from "react";
import { shopApi } from "../../context/ShopAuthContext";
import { agentError } from "./common";

export const useCoreRecords = (resource, enabled=true) => {
  const [query, setQuery] = useState("");
  const [offset, setOffset] = useState(0);
  const [data, setData] = useState({ items: [], total: 0, limit: 50 });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const load = useCallback(async () => {
    if(!enabled){setData({items:[],total:0,limit:50});setLoading(false);setError("");return;}
    setLoading(true); setError("");
    try { const r = await shopApi.get(`/agent-access/core/${resource}`, { params: {q: query, offset} }); setData(r.data); }
    catch(e) { setError(agentError(e)); setData({ items: [], total: 0, limit: 50 }); }
    finally { setLoading(false); }
  }, [resource, query, offset, enabled]);
  useEffect(() => { const timer = setTimeout(load, 180); return () => clearTimeout(timer); }, [load]);
  return { ...data, query, setQuery: value => { setQuery(value); setOffset(0); }, offset, setOffset, error, loading, load };
};